/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'bot-class-matcher-readonly';
const prefix = `${moduleName}.${componentName}`;

export const clientClassLabel = `${prefix}.clientClassLabel`;

export const ENGLISH = {
    [clientClassLabel]: 'Client Class',
};
